import { useMutation } from '@tanstack/react-query'

import type { MutationFeedback } from '@/integrations/tanstack-query/types'

import type { RestoreEnvelopeParams } from './restore-envelope'
import {
  RESTORE_ENVELOPE_QUERY_KEYS,
  restoreEnvelope,
} from './restore-envelope'

export const useRestoreEnvelope = (feedback?: MutationFeedback) => {
  return useMutation({
    mutationFn: (params: RestoreEnvelopeParams) => restoreEnvelope(params),
    meta: {
      invalidatesQuery: RESTORE_ENVELOPE_QUERY_KEYS,
      ...feedback,
    },
  })
}
